import styles from './accountDetailsInfopopup.scss';
import CustomAnchorTag from '../../Common/CommonComponents/CustomAnchorTag/customAnchorTag';
import { getLocalizedStrings } from '../../MyAccountLanding/SingleAccount/singleAccountLocalizedStrings';

export default class infoPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            infoPopup: false,
            left: 0,
            width: 375,
            showModalAtTop:true,
            right:0,
            top:35,
        };
        this.strings = getLocalizedStrings('serviceAccountComponent');
        this.imageInfo = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_infio.svg';
        this.popupRef = React.createRef();
        this.calculateScrollPos=this.calculateScrollPos.bind(this);
    }
    componentDidMount(){
        document.addEventListener('click', this.handClickOutside);
        const scroll_element = document.getElementById("infoPopupContent");
        scroll_element.addEventListener('scroll', this.calculateScrollPos);
    }
    componentWillUnmount(){
        document.removeEventListener('click', this.handClickOutside);
        const scroll_element = document.getElementById("infoPopupContent");
        scroll_element.removeEventListener('scroll', this.calculateScrollPos);
    }
    calculateScrollPos = (e) => {
        const info_y = document.getElementById(this.props.content);
        if(this.state.infoPopup && this.state.clientBoundVal!==undefined && info_y.getBoundingClientRect().y!==this.state.clientBoundVal){
            this.dynamicInfoPopup(info_y, this.state.left);
        }
    }
    handleClick = (e) => {
        const xPosition = e.clientX;
        const widthParen = e.currentTarget.parentElement.parentElement.offsetWidth;
        const elem_y = e.target;
        this.calculatPosistion(xPosition, widthParen, elem_y);
        this.openInfoPopup();
    }
    handClickOutside = (event) => {
        if(this.popupRef.current && !this.popupRef.current.contains(event.target)){
            {this.setState({infoPopup: false});}
        }
    };
    openInfoPopup = () => { this.setState((prevState) => ({ infoPopup: !prevState.infoPopup })); }
    toolTipKeyPress= (e) =>{
        if(e.key === "Enter"){
            const xPosition = e.target.getBoundingClientRect().left;
            const widthParent=e.currentTarget.parentElement.parentElement.offsetWidth;
            const elem_y = e.target;
            this.calculatPosistion(xPosition, widthParent, elem_y);
            this.openInfoPopup();
        }}
        calculatPosistion = (xPosition, widthParent, elem_y) => {
            let viewPortWidth = window.innerWidth;
            let halfPortWidth = viewPortWidth/2;
            let widthCalc = Math.min(viewPortWidth * 0.7, 375);
            let popUpWidth = Math.min(viewPortWidth * 0.7, 324);
            let halfPopWidth = popUpWidth/2;
            let leftPosition = 0;
            if(xPosition){
             leftPosition = -(xPosition/halfPortWidth * halfPopWidth);
            }
                
            if(viewPortWidth<=375){
                viewPortWidth = widthParent;
                halfPortWidth = viewPortWidth/2;
                popUpWidth = Math.min(viewPortWidth * 0.6, 220);
                widthCalc = popUpWidth+3;
                halfPopWidth = popUpWidth/2;
                if(xPosition){
                    leftPosition = -(xPosition/halfPortWidth * halfPopWidth);
                }                
            }
            this.setState({
                left: leftPosition,
                width: widthCalc
            });  
            this.dynamicInfoPopup(elem_y, leftPosition);
    }
    dynamicInfoPopup = (elem, leftPosition) => {
        const scroll_element = document.getElementById("infoPopupContent");
        const elem_y = elem ? (Math.round(elem.getBoundingClientRect().y)) : -1, 
        scroll_midPoint = (Math.round(scroll_element.getBoundingClientRect().top)+Math.round(scroll_element.getBoundingClientRect().bottom))/2; 
        let showModalAtTop = elem_y>scroll_midPoint?true:false;
       let top = 35;
       let leftD = leftPosition;
       if(!showModalAtTop){
           leftD=elem?elem.offsetLeft+leftPosition+15:leftPosition ;
           top = 35+(elem?elem.offsetTop-1:0); 
       }else{
           leftD = leftPosition;
       }
       this.setState({ showModalAtTop: showModalAtTop, leftD:leftD, top:top, clientBoundVal: elem.getBoundingClientRect().y});
   }
    displayContent = (isMobile) => {
        switch (this.props.content) {
           
            case 'PODID':
                return (
                    <div className={styles.sceInfoPopupContent}>
                        {'This is an additional customer identification field for your reference for your billing inquiries. The POD ID can also be located near your Service Account number on your bill.' || this.strings.popIdInfoPopUp}
                    </div>
                );
            case 'ROG':
                return (
                    <div className={styles.sceInfoPopupContent}>
                        {'Rotating Outages help avoid widespread or uncontrolled blackouts during system emergencies. SCE accounts in groups A, M, R, S and X are subject to rotating outages. Group can change, without notice, at any time.' || this.strings.rogInfoPopUp}
                    </div>
                );
            
            case 'RIN':
            return (
                <div className={styles.sceInfoPopupContent}>
                    If you have smart device, such as a smart thermostat, an EV charger, or an energy management system, you may be able to use this Rate Identification Number (RIN) to program your device to manage your electricity usage. For additional information, go to <CustomAnchorTag link={'/helpcenter/rin'} linkName='/helpcenter/rin' sceLearnMore />
                </div>
            );
        }
    }
    render() {
        const isMobile = app.appUtil.detectMobile();
        const isSavingsProg = ['SDP', 'SEP', 'CRFR'].includes( this.props.content ) ? true : false;
        const contentStyling = this.props.content === "RIN" && isMobile ? "-52vw":"unset";
        return (
            <div ref={this.popupRef}>
            <span className={styles.sceWrapper}>{this.props.heading} <img id={this.props.content} className={styles.sceInfoIcon} src={this.imageInfo} alt="Info Icon" onClick={(e)=>this.handleClick(e)} tabIndex={0} onKeyPress={(e)=> this.toolTipKeyPress(e)} />
            {this.state.infoPopup ? <span className={this.state.showModalAtTop?styles.sceTooltip:styles.sceTooltipDown}><span style={{ width: `${this.state.width}px`, left: contentStyling}} className={isMobile ? this.state.showModalAtTop?styles.sceMobContent:styles.sceMobContentDown : this.state.showModalAtTop?styles.sceContent:styles.sceContentDown}> {this.displayContent(isMobile)} </span> </span> : null }
            </span>
            </div>
        );
    }
}
